<template>
	<v-main>
		<v-row class="mx-auto">
			<v-col cols="12" sm="12" lg="8" offset-lg="2" no-gutters class="text-center">
				<v-img max-height="80" :src="imagotipo" contain class="mb-2 mt-15"/>
				<h1>
					e-Boleta
				</h1>
				<v-row no-gutters class="pa-5 signin-btns" v-if="!loading">
						<v-col cols="12" xs="12" class="text-center pb-4">
							<span class="text-h6 grey--text text--darken-2">
								Identificación de contribuyentes
							</span>
						</v-col>
						<v-col cols="12" xs="12">
							<IdentityProviders/>
						</v-col>
					</v-row>
				<v-overlay :value="loading">
					<div class="mb-5">Iniciando sesión...</div>
					<v-progress-circular indeterminate size="64"/>
				</v-overlay>
			</v-col>
		</v-row>
		<v-snackbar
			:value="$store.getters['usuario/authStatus'] === 'error'"
			multi-line
			color="error"
		>
			Ha ocurrido un error al iniciar sesión
		</v-snackbar>
	</v-main>
</template>
<script>

import { identityProviders } from '@/config';
import imagotipo from '@/assets/sii-imagotipo.svg'

import IdentityProviders from './IdentityProviders'

export default {
	components:{
		IdentityProviders
	},
	computed: {
		imagotipo(){return imagotipo}
		,loading(){return this.$store.getters['sesion/loading']}
	},
	data(){
		return {
			identityProviders: identityProviders,
		}
	},
	methods: {
		async iniciarSesion(versionCheckeada=false){
		
			if(versionCheckeada){
				const opts = this.$store.state.sesion.signInInfo;
				
				await this.$store.dispatch('usuario/signIn', {opts, versionCheckeada});
				this.$store.dispatch('sesion/sesionIniciada');
				this.$router.push({name: 'calculadora'});
			}
		}
		,async signInClaveTributaria(){

			const url = this.identityProviders.claveTributaria.getUrl()
			const provider = this.identityProviders.claveTributaria.name

			const payload = {url, provider}
			this.$store.dispatch('sesion/inciarSesion', payload)
		}
	}
	,async mounted(){
		this.signInClaveTributaria();
	}
}
</script>